var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.value
    ? _c(
        "div",
        {
          staticClass: "quote-insurer is-flex cell is-col-span-1",
          staticStyle: { position: "relative" },
          attrs: { inert: _vm.isSaving },
          on: { focusout: _vm.onComponentFocusOut },
        },
        [
          _vm.isSaving
            ? _c("div", { staticClass: "quote-item-saving-overlay" })
            : _vm._e(),
          _c("article", { staticClass: "box is-flex-grow-1" }, [
            _vm._m(0),
            _c("div", { staticClass: "is-divider" }),
            _c("div", { staticClass: "field" }, [
              _c("label", { staticClass: "label is-required-label" }, [
                _vm._v("Insurer"),
              ]),
              _c(
                "div",
                {
                  staticClass: "control",
                  attrs: {
                    title: _vm.isAdditionalQuote
                      ? "Insurer can only be changed on the main quote"
                      : "",
                  },
                },
                [
                  _vm.readOnlyView
                    ? _c("input", {
                        staticClass: "input is-static",
                        attrs: { readonly: "" },
                        domProps: {
                          value: _vm.quoteInsurer ? _vm.quoteInsurer.name : "",
                        },
                      })
                    : !_vm.readOnlyView && _vm.insurers
                    ? _c(
                        "multiselect",
                        {
                          class: [
                            _vm.$v.insurer.insurerId.$error ||
                            _vm.$v.insurer.name.$error
                              ? "is-invalid"
                              : "is-required-field",
                          ],
                          attrs: {
                            "deselect-label": "Can't remove this value",
                            "track-by": "assetId",
                            label: "assetName",
                            placeholder: "Search By Name...",
                            options: _vm.insurers,
                            loading: _vm.isInsurerLoading,
                            "internal-search": false,
                            "options-limit": _vm.insurerFilter.pageSize,
                            searchable: true,
                            "show-labels": false,
                            "allow-empty": false,
                            disabled: _vm.isInsurerDropdownDisabled,
                          },
                          on: {
                            select: _vm.selectInsurer,
                            remove: _vm.removeInsurer,
                            "search-change": _vm.getInsurerDropdownFilter,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "option",
                                fn: function (props) {
                                  return [
                                    _c("span", [
                                      _vm._v(_vm._s(props.option.assetName)),
                                    ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            2645691248
                          ),
                          model: {
                            value: _vm.selectedInsurer,
                            callback: function ($$v) {
                              _vm.selectedInsurer = $$v
                            },
                            expression: "selectedInsurer",
                          },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "has-text-danger",
                              attrs: { slot: "noResult" },
                              slot: "noResult",
                            },
                            [_vm._v("Insurer not found.")]
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "field" }, [
              _c("label", { staticClass: "label" }, [_vm._v("ABN")]),
              _c(
                "div",
                { staticClass: "control has-icons-right" },
                [
                  _c("the-mask", {
                    staticClass: "input",
                    class: { "is-danger": _vm.$v.insurer.abn.$error },
                    attrs: {
                      type: "text",
                      placeholder: "ABN",
                      mask: ["## ### ### ###"],
                      disabled: "",
                    },
                    nativeOn: {
                      input: function ($event) {
                        return _vm.$v.insurer.abn.$touch()
                      },
                    },
                    model: {
                      value: _vm.innerInsurer.abn,
                      callback: function ($$v) {
                        _vm.$set(_vm.innerInsurer, "abn", $$v)
                      },
                      expression: "innerInsurer.abn",
                    },
                  }),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "field" }),
            _c("div", { staticClass: "field" }, [
              _c("div", { staticClass: "field-body" }, [
                _c("div", { staticClass: "field" }, [
                  _c("label", { staticClass: "label" }, [
                    _vm._v("Claim Number"),
                  ]),
                  _c("div", { staticClass: "control" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.innerQuote.claimNo,
                          expression: "innerQuote.claimNo",
                        },
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: {
                            theme: "danger",
                            enabled: _vm.$v.entity.claimNo.$error,
                          },
                          expression:
                            "{ theme: 'danger', enabled: $v.entity.claimNo.$error }",
                        },
                      ],
                      staticClass: "input",
                      class: { "is-invalid": _vm.$v.entity.claimNo.$error },
                      attrs: {
                        content: _vm.claimNoValidationText,
                        type: "text",
                        disabled:
                          _vm.innerQuote.readOnly ||
                          _vm.audanetLock ||
                          _vm.isAdditionalQuote,
                        placeholder: "Claim Number",
                      },
                      domProps: { value: _vm.innerQuote.claimNo },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.innerQuote,
                            "claimNo",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]),
                ]),
                _c("div", { staticClass: "field" }, [
                  _c("label", { staticClass: "label" }, [
                    _vm._v("Policy Number"),
                  ]),
                  _c("div", { staticClass: "control" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.innerQuote.policyNo,
                          expression: "innerQuote.policyNo",
                        },
                      ],
                      staticClass: "input",
                      attrs: { type: "text", placeholder: "Policy No." },
                      domProps: { value: _vm.innerQuote.policyNo },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.innerQuote,
                            "policyNo",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "field" }, [
              _c("div", { staticClass: "field-body" }, [
                _c("div", { staticClass: "field is-expanded" }, [
                  _c("label", { staticClass: "label" }, [
                    _vm._v("Labour Times"),
                  ]),
                  _c("div", { staticClass: "control" }, [
                    _vm.readOnlyView
                      ? _c("input", {
                          staticClass: "input is-static",
                          attrs: { readonly: "" },
                          domProps: { value: _vm.innerQuote.labourType },
                        })
                      : _c("div", { staticClass: "select is-fullwidth" }, [
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.innerQuote.labourType,
                                  expression: "innerQuote.labourType",
                                },
                              ],
                              attrs: {
                                disabled:
                                  _vm.innerQuote.readOnly || _vm.audanetLock,
                              },
                              on: {
                                change: function ($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected
                                    })
                                    .map(function (o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.$set(
                                    _vm.innerQuote,
                                    "labourType",
                                    $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  )
                                },
                              },
                            },
                            _vm._l(
                              _vm.labourTimesTypeEnum,
                              function (labourType, propertyName, index) {
                                return _c(
                                  "option",
                                  {
                                    key: index,
                                    domProps: { value: propertyName },
                                  },
                                  [_vm._v(" " + _vm._s(labourType) + " ")]
                                )
                              }
                            ),
                            0
                          ),
                        ]),
                  ]),
                ]),
                _c("div", { staticClass: "field is-expanded" }, [
                  _c("label", { staticClass: "label" }, [_vm._v("Method")]),
                  _c("div", { staticClass: "control" }, [
                    _c(
                      "div",
                      { staticClass: "buttons has-addons is-fullwidth" },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "button",
                            class: {
                              "has-text-weight-semibold has-text-primary is-selected":
                                _vm.innerQuote.quotingMethod ===
                                _vm.quotingMethodTypes.Hour,
                            },
                            attrs: {
                              disabled:
                                _vm.innerQuote.readOnly ||
                                _vm.audanetLock ||
                                (_vm.quote.quoteAssessments &&
                                  _vm.quote.quoteAssessments.length > 0),
                            },
                            on: {
                              click: function ($event) {
                                _vm.innerQuote.quotingMethod =
                                  _vm.quotingMethodTypes.Hour
                              },
                            },
                          },
                          [
                            _c("span", { staticClass: "icon" }, [
                              _c("i", {
                                staticClass:
                                  "icon mdi mdi-clock-outline mdi-20px",
                                class: {
                                  "has-text-weight-bold has-text-primary":
                                    _vm.innerQuote.quotingMethod ===
                                    _vm.quotingMethodTypes.Hour,
                                },
                              }),
                            ]),
                            _c("span", [_vm._v("Hours")]),
                          ]
                        ),
                        _c(
                          "button",
                          {
                            staticClass: "button",
                            class: {
                              "has-text-weight-semibold has-text-primary is-selected":
                                _vm.innerQuote.quotingMethod ===
                                _vm.quotingMethodTypes.Dollar,
                            },
                            attrs: {
                              disabled:
                                _vm.innerQuote.readOnly ||
                                _vm.audanetLock ||
                                (_vm.quote.quoteAssessments &&
                                  _vm.quote.quoteAssessments.length > 0),
                            },
                            on: {
                              click: function ($event) {
                                _vm.innerQuote.quotingMethod =
                                  _vm.quotingMethodTypes.Dollar
                              },
                            },
                          },
                          [
                            _c("span", { staticClass: "icon" }, [
                              _c("i", {
                                staticClass:
                                  "icon mdi mdi-cash-multiple mdi-20px",
                                class: {
                                  "has-text-weight-bold has-text-primary":
                                    _vm.innerQuote.quotingMethod ===
                                    _vm.quotingMethodTypes.Dollar,
                                },
                              }),
                            ]),
                            _c("span", [_vm._v("Dollars")]),
                          ]
                        ),
                      ]
                    ),
                  ]),
                ]),
              ]),
            ]),
            false
              ? _c("div", { staticClass: "field" }, [
                  _c("div", { staticClass: "field-body" }, [
                    _c("div", { staticClass: "field" }, [
                      _c("label", { staticClass: "label" }, [_vm._v("ABN")]),
                      _c(
                        "div",
                        { staticClass: "control has-icons-right" },
                        [
                          _c("the-mask", {
                            staticClass: "input",
                            class: { "is-invalid": _vm.$v.insurer.abn.$error },
                            attrs: {
                              type: "text",
                              placeholder: "ABN",
                              mask: ["## ### ### ###"],
                            },
                            model: {
                              value: _vm.innerInsurer.abn,
                              callback: function ($$v) {
                                _vm.$set(_vm.innerInsurer, "abn", $$v)
                              },
                              expression: "innerInsurer.abn",
                            },
                          }),
                          !_vm.$v.insurer.abn.$error && _vm.innerInsurer.abn
                            ? _c(
                                "span",
                                {
                                  staticClass: "icon has-text-success is-right",
                                },
                                [
                                  _c("i", {
                                    staticClass: "mdi mdi-check mdi-18px",
                                  }),
                                ]
                              )
                            : _vm._e(),
                          !_vm.$v.insurer.abn.minLength
                            ? _c("span", { staticClass: "help is-danger" }, [
                                _vm._v(
                                  "ABN must be at least " +
                                    _vm._s(
                                      _vm.$v.insurer.abn.$params.minLength.min
                                    ) +
                                    " letters."
                                ),
                              ])
                            : !_vm.$v.insurer.abn.validAbn
                            ? _c("span", { staticClass: "help is-danger" }, [
                                _vm._v("ABN format is invalid."),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]),
                    _c("div", { staticClass: "field" }, [
                      _c("label", { staticClass: "label" }, [_vm._v("ARBN")]),
                      _c(
                        "div",
                        { staticClass: "control has-icons-right" },
                        [
                          _c("the-mask", {
                            staticClass: "input",
                            class: { "is-invalid": _vm.$v.insurer.arbn.$error },
                            attrs: {
                              type: "text",
                              placeholder: "ARBN",
                              mask: ["### ### ###"],
                            },
                            model: {
                              value: _vm.innerInsurer.arbn,
                              callback: function ($$v) {
                                _vm.$set(_vm.innerInsurer, "arbn", $$v)
                              },
                              expression: "innerInsurer.arbn",
                            },
                          }),
                          !_vm.$v.insurer.arbn.$error && _vm.innerInsurer.arbn
                            ? _c(
                                "span",
                                {
                                  staticClass: "icon has-text-success is-right",
                                },
                                [
                                  _c("i", {
                                    staticClass: "mdi mdi-check mdi-18px",
                                  }),
                                ]
                              )
                            : _vm._e(),
                          !_vm.$v.insurer.arbn.minLength
                            ? _c("span", { staticClass: "help is-danger" }, [
                                _vm._v(
                                  "ARBN must be at least " +
                                    _vm._s(
                                      _vm.$v.insurer.arbn.$params.minLength.min
                                    ) +
                                    " letters."
                                ),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]),
                  ]),
                ])
              : _vm._e(),
            false
              ? _c("div", { staticClass: "field" }, [
                  _c("div", { staticClass: "field-body" }, [
                    _c("div", { staticClass: "field" }, [
                      _c("label", { staticClass: "label" }, [_vm._v("BSB")]),
                      _c(
                        "div",
                        { staticClass: "control" },
                        [
                          _c("the-mask", {
                            staticClass: "input",
                            attrs: {
                              type: "text",
                              placeholder: "BSB",
                              mask: ["###-###"],
                            },
                            model: {
                              value: _vm.innerInsurer.bsb,
                              callback: function ($$v) {
                                _vm.$set(_vm.innerInsurer, "bsb", $$v)
                              },
                              expression: "innerInsurer.bsb",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _c("div", { staticClass: "field" }, [
                      _c("label", { staticClass: "label" }, [
                        _vm._v("Account No."),
                      ]),
                      _c("div", { staticClass: "control" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.innerInsurer.accoutNo,
                              expression: "innerInsurer.accoutNo",
                            },
                          ],
                          staticClass: "input uppercase",
                          attrs: { type: "text", placeholder: "Account No." },
                          domProps: { value: _vm.innerInsurer.accoutNo },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.innerInsurer,
                                "accoutNo",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]),
                    ]),
                  ]),
                ])
              : _vm._e(),
            _c("div", { staticClass: "field" }, [
              _c("div", { staticClass: "field-body" }, [
                _c("div", { staticClass: "field" }, [
                  _c(
                    "div",
                    { staticClass: "is-flex is-justify-content-space-between" },
                    [
                      _c("label", { staticClass: "label" }, [_vm._v("Excess")]),
                      _c(
                        "div",
                        {
                          staticClass:
                            "is-flex is-align-items-center is-justify-content-end mb-2",
                        },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "pr-1 is-size-7",
                              class: {
                                "pretty-checkbox-label":
                                  !_vm.disableExcessIncludesGST,
                              },
                            },
                            [_vm._v("Includes GST")]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "pretty p-icon p-round p-smooth m-0 is-size-7",
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.innerQuote.excessWithGst,
                                    expression: "innerQuote.excessWithGst",
                                  },
                                ],
                                attrs: {
                                  id: "chk-excessWithGst",
                                  type: "checkbox",
                                  disabled: _vm.disableExcessIncludesGST,
                                },
                                domProps: {
                                  checked: Array.isArray(
                                    _vm.innerQuote.excessWithGst
                                  )
                                    ? _vm._i(
                                        _vm.innerQuote.excessWithGst,
                                        null
                                      ) > -1
                                    : _vm.innerQuote.excessWithGst,
                                },
                                on: {
                                  change: function ($event) {
                                    var $$a = _vm.innerQuote.excessWithGst,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            _vm.innerQuote,
                                            "excessWithGst",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            _vm.innerQuote,
                                            "excessWithGst",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(
                                        _vm.innerQuote,
                                        "excessWithGst",
                                        $$c
                                      )
                                    }
                                  },
                                },
                              }),
                              _vm._m(1),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "control" },
                    [
                      _vm.readOnlyView
                        ? _c("input", {
                            staticClass: "input is-static",
                            attrs: { readonly: "" },
                            domProps: {
                              value: _vm.$filters.formatNumber(
                                _vm.excess,
                                _vm.$userInfo.locale
                              ),
                            },
                          })
                        : _c("vue-numeric", {
                            staticClass: "input has-text-right",
                            attrs: {
                              min: 0,
                              placeholder: "Excess",
                              precision: 2,
                              disabled:
                                _vm.innerQuote.readOnly ||
                                _vm.audanetLock ||
                                _vm.innerQuote.subQuoteNo > 0 ||
                                _vm.hasInvoice,
                            },
                            on: {
                              blur: function ($event) {
                                return _vm.calculateExcess()
                              },
                            },
                            model: {
                              value: _vm.excess,
                              callback: function ($$v) {
                                _vm.excess = $$v
                              },
                              expression: "excess",
                            },
                          }),
                    ],
                    1
                  ),
                ]),
                _c("div", { staticClass: "field" }, [
                  _c("label", { staticClass: "label" }, [
                    _vm._v("Owners Contribution"),
                  ]),
                  _c(
                    "div",
                    { staticClass: "control" },
                    [
                      _vm.readOnlyView
                        ? _c("input", {
                            staticClass: "input is-static",
                            attrs: { readonly: "" },
                            domProps: {
                              value: _vm.$filters.formatNumber(
                                _vm.innerQuote.ownersContribution,
                                _vm.$userInfo.locale
                              ),
                            },
                          })
                        : _c("vue-numeric", {
                            staticClass: "input has-text-right",
                            attrs: {
                              min: 0,
                              placeholder: "Owner's Contribution",
                              precision: 2,
                              disabled: _vm.disableOwnerContribution,
                            },
                            model: {
                              value: _vm.innerQuote.ownersContribution,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.innerQuote,
                                  "ownersContribution",
                                  $$v
                                )
                              },
                              expression: "innerQuote.ownersContribution",
                            },
                          }),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "field" }, [
              _c("div", { staticClass: "field-body" }, [
                _c("div", { staticClass: "field" }, [
                  _c("label", { staticClass: "label" }, [
                    _vm._v("Discount On Invoice"),
                  ]),
                  _c(
                    "div",
                    { staticClass: "control" },
                    [
                      _vm.readOnlyView
                        ? _c("div", { staticClass: "control" }, [
                            _c("input", {
                              staticClass: "input is-static",
                              attrs: { readonly: "" },
                              domProps: {
                                value: _vm.$filters.formatNumber(
                                  _vm.innerQuote.discount,
                                  _vm.$userInfo.locale
                                ),
                              },
                            }),
                          ])
                        : _c("vue-numeric", {
                            staticClass: "input has-text-right",
                            attrs: {
                              min: 0,
                              formats: "",
                              placeholder: "Discount applied on invoice",
                              precision: 2,
                              symbol: _vm.$company.currency.symbol,
                              disabled:
                                _vm.innerQuote.readOnly ||
                                _vm.audanetLock ||
                                _vm.innerQuote.subQuoteNo > 0 ||
                                _vm.hasInvoice,
                            },
                            model: {
                              value: _vm.innerQuote.discount,
                              callback: function ($$v) {
                                _vm.$set(_vm.innerQuote, "discount", $$v)
                              },
                              expression: "innerQuote.discount",
                            },
                          }),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.innerInsurer.damageSeverity,
                    expression: "innerInsurer.damageSeverity",
                  },
                ],
                staticClass: "field",
              },
              [
                _c("label", { staticClass: "label" }, [
                  _vm._v("Damage Severity"),
                ]),
                _c("div", { staticClass: "control" }, [
                  _c(
                    "div",
                    {
                      staticClass: "select is-fullwidth",
                      class: {
                        "is-invalid": _vm.$v.entity.damageSeverity.$error,
                      },
                    },
                    [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.innerQuote.damageSeverity,
                              expression: "innerQuote.damageSeverity",
                            },
                          ],
                          staticClass: "select-width",
                          attrs: { disabled: _vm.innerQuote.readOnly },
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.innerQuote,
                                "damageSeverity",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            },
                          },
                        },
                        _vm._l(
                          _vm.damageSeverityTypes,
                          function (damageSeverityType, propertyName, index) {
                            return _c(
                              "option",
                              {
                                key: index,
                                domProps: { value: damageSeverityType },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.getDamageSeverityDescription(
                                        propertyName
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            )
                          }
                        ),
                        0
                      ),
                    ]
                  ),
                ]),
              ]
            ),
            _c("div", { staticClass: "columns field" }, [
              _c("div", { staticClass: "column" }, [
                _c("div", { staticClass: "field" }, [
                  _c("label", { staticClass: "label" }, [_vm._v("Assessor")]),
                  _c(
                    "div",
                    { staticClass: "control" },
                    [
                      _c("bulma-autocomplete", {
                        key: "assessorName",
                        attrs: {
                          placeholder: "Assessor",
                          data: _vm.assessorList,
                          loading: false,
                          field: "assessorName",
                          disabled: _vm.readOnlyView,
                        },
                        on: {
                          input: (v) =>
                            _vm.getAssessorList(
                              v ? v.replace(/[^a-zA-Z\s]/g, "") : ""
                            ),
                          search: _vm.getAssessorList,
                          select: _vm.handleSelectedAssessor,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (props) {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "is-flex is-align-items-center",
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "icon is-small" },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "mdi mdi-account mdi-18px",
                                          }),
                                        ]
                                      ),
                                      _c("span", { staticClass: "pl-1" }, [
                                        _vm._v(
                                          _vm._s(
                                            props.option.assessorName ||
                                              "no name"
                                          )
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "is-flex is-align-items-center",
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "icon is-small" },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "mdi mdi-phone mdi-14px",
                                          }),
                                        ]
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "is-size-7 has-text-grey-light pl-1",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              props?.option?.assessorPhoneNo ||
                                                "-"
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3339859973
                        ),
                        model: {
                          value: _vm.innerQuote.assessorName,
                          callback: function ($$v) {
                            _vm.$set(_vm.innerQuote, "assessorName", $$v)
                          },
                          expression: "innerQuote.assessorName",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
              _c("div", { staticClass: "column" }, [
                _c("div", { staticClass: "field" }, [
                  _c("label", { staticClass: "label" }, [
                    _vm._v("Phone Number"),
                  ]),
                  _c(
                    "div",
                    { staticClass: "control" },
                    [
                      _c("the-mask", {
                        staticClass: "input",
                        class: { "is-static": _vm.readOnlyView },
                        attrs: {
                          mask: _vm.phoneNoMask,
                          tokens: _vm.phoneNoTokens,
                          type: "text",
                          placeholder: !_vm.readOnlyView ? "xxxxxxxxx" : "",
                          disabled: _vm.readOnlyView,
                        },
                        model: {
                          value: _vm.innerQuote.assessorPhoneNo,
                          callback: function ($$v) {
                            _vm.$set(_vm.innerQuote, "assessorPhoneNo", $$v)
                          },
                          expression: "innerQuote.assessorPhoneNo",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "field" }, [
              _c("label", { staticClass: "label" }, [_vm._v("Estimator")]),
              _vm.readOnlyView
                ? _c("div", { staticClass: "control" }, [
                    _c("input", {
                      staticClass: "input is-static is-capitalized",
                      attrs: { readonly: "" },
                      domProps: { value: _vm.innerQuote.quoter },
                    }),
                  ])
                : _c(
                    "div",
                    { staticClass: "control" },
                    [
                      _c("bulma-autocomplete", {
                        attrs: {
                          placeholder: "Quoter",
                          data: _vm.filteredQuoters,
                          "keep-first": true,
                          loading: false,
                          "class-prop": _vm.$v.entity.quoter.$error
                            ? "is-capitalized is-invalid"
                            : "is-capitalized",
                        },
                        model: {
                          value: _vm.innerQuote.quoter,
                          callback: function ($$v) {
                            _vm.$set(_vm.innerQuote, "quoter", $$v)
                          },
                          expression: "innerQuote.quoter",
                        },
                      }),
                    ],
                    1
                  ),
            ]),
            _c("div", { staticClass: "field" }, [
              _vm.includeClaimsType
                ? _c("div", { staticClass: "field" }, [
                    _c(
                      "div",
                      { staticClass: "control is-expanded" },
                      [
                        _c(
                          "multiselect",
                          {
                            attrs: {
                              options: _vm.claimsTypes,
                              "preserve-search": true,
                              "track-by": "key",
                              "internal-search": true,
                              searchable: true,
                              "show-labels": false,
                              placeholder: "Select Claims type",
                              label: "description",
                              "allow-empty": true,
                            },
                            on: { select: _vm.onClaimsTypeChange },
                            model: {
                              value: _vm.selectedClaimsType,
                              callback: function ($$v) {
                                _vm.selectedClaimsType = $$v
                              },
                              expression: "selectedClaimsType",
                            },
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "has-text-danger",
                                attrs: { slot: "noResult" },
                                slot: "noResult",
                              },
                              [_vm._v("Claims type not found.")]
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
            ]),
            _c("div", { staticClass: "field" }, [
              _c(
                "div",
                {
                  staticClass: "is-flex mt-5",
                  class: {
                    "is-justify-content-space-between":
                      _vm.innerInsurer.inScope,
                    "is-justify-content-start": !_vm.innerInsurer.inScope,
                  },
                },
                [
                  _c("div", { staticClass: "mr-6" }, [
                    _c("label", { staticClass: "label" }, [_vm._v("Is Towed")]),
                    _c("div", { staticClass: "control" }, [
                      _c("div", { staticClass: "pretty p-switch p-fill" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.innerQuote.isTowed,
                              expression: "innerQuote.isTowed",
                            },
                          ],
                          attrs: { type: "checkbox" },
                          domProps: {
                            checked: !!_vm.innerQuote.isTowed,
                            checked: Array.isArray(_vm.innerQuote.isTowed)
                              ? _vm._i(_vm.innerQuote.isTowed, null) > -1
                              : _vm.innerQuote.isTowed,
                          },
                          on: {
                            change: function ($event) {
                              var $$a = _vm.innerQuote.isTowed,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      _vm.innerQuote,
                                      "isTowed",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      _vm.innerQuote,
                                      "isTowed",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(_vm.innerQuote, "isTowed", $$c)
                              }
                            },
                          },
                        }),
                        _c("div", { staticClass: "state p-primary" }, [
                          _c("label", [
                            _vm._v(
                              _vm._s(_vm.innerQuote.isTowed ? "Yes" : "No")
                            ),
                          ]),
                        ]),
                      ]),
                    ]),
                  ]),
                  _vm.$company.setting.driveable
                    ? _c("div", { staticClass: "mr-6" }, [
                        _c("label", { staticClass: "label" }, [
                          _vm._v("Driveable"),
                        ]),
                        _c("div", { staticClass: "control" }, [
                          _c("div", { staticClass: "pretty p-switch p-fill" }, [
                            _c("input", {
                              attrs: { type: "checkbox" },
                              domProps: { checked: !!_vm.innerQuote.driveable },
                              on: { change: _vm.driveableOnChange },
                            }),
                            _c("div", { staticClass: "state p-primary" }, [
                              _c("label", [
                                _vm._v(
                                  _vm._s(
                                    _vm.innerQuote.driveable ? "Yes" : "No"
                                  )
                                ),
                              ]),
                            ]),
                          ]),
                        ]),
                      ])
                    : _vm._e(),
                  _vm.innerInsurer.inScope
                    ? _c("div", [
                        _c("label", { staticClass: "label" }, [
                          _vm._v("In Scope"),
                        ]),
                        _c("div", { staticClass: "control" }, [
                          _c("div", { staticClass: "pretty p-switch p-fill" }, [
                            _c("input", {
                              attrs: { type: "checkbox" },
                              domProps: { checked: !!_vm.innerQuote.inScope },
                              on: { change: _vm.inScopeOnChange },
                            }),
                            _c("div", { staticClass: "state p-primary" }, [
                              _c("label", [
                                _vm._v(
                                  _vm._s(_vm.innerQuote.inScope ? "Yes" : "No")
                                ),
                              ]),
                            ]),
                          ]),
                        ]),
                      ])
                    : _vm._e(),
                ]
              ),
            ]),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "columns mb-0" }, [
      _c("div", { staticClass: "column is-flex is-align-items-center" }, [
        _c("i", { staticClass: "icon mdi mdi-shield-outline mdi-24px" }),
        _c("p", { staticClass: "title pl-1" }, [_vm._v("Insurer/Debtor")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "state p-primary" }, [
      _c("i", { staticClass: "icon mdi mdi-check" }),
      _c("label"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }